import {
  GET_USER,
  CLEAR_USER,
  LOAD_START,
  LOAD_END,
  SET_ERROR,
} from "../actions/SuperAdmin/types";
import {
  UPDATE_TOUR_STATE,
  TOUR_SKIP_CHECK,
  OPEN_SLIDER,
  SET_GUIDE_STEPS,
} from "../actions/Admin/types";
const initialState = {
  user: {},
  loading: false,
  error: null,
  run: false,
  stepIndex: 0,
  steps: [],
  tourActive: false,
  tourDontShow: false,
  openSlider: false,
};

const userReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_USER:
      return { ...state, user: payload };
    case CLEAR_USER:
      return { ...state, user: {} };
    case LOAD_START:
      return { ...state, loading: true };
    case LOAD_END:
      return { ...state, loading: false };
    case SET_ERROR:
      return { ...state, error: payload };
    case OPEN_SLIDER:
      return {
        ...state,
        openSlider: payload,
      };
    ////// tour state
    case SET_GUIDE_STEPS:
      return {
        ...state,
        steps: payload,
      };
    case UPDATE_TOUR_STATE:
      return {
        ...state,
        run: payload.run,
        stepIndex:
          payload.stepIndex === null ? state.stepIndex : payload.stepIndex,
        tourActive: payload.tourActive,
      };
    case TOUR_SKIP_CHECK:
      return {
        ...state,
        tourDontShow: payload,
      };
    ////////////////
    default:
      return state;
  }
};

export default userReducer;
